import React from "react";
import { useMsal } from "@azure/msal-react";
import { FaSignOutAlt } from "react-icons/fa";
import { Button } from 'react-bootstrap';

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <>
      <Button variant="primary" onClick={() => handleLogout("redirect")} className="signout-button">
        <FaSignOutAlt className="icon" />
        LOGGA UT
      </Button>
    </>
  );
};
